// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__-hXFu","modal":"Modal_modal__iQf2R","slide-down":"Modal_slide-down__m+6ME"};